/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { callbackService } from "publicApis/controller/callbackService";
import { GET_LOCAL_FONT_PRIMING_DIALOG } from "../constants/constants";

export const getLocalFontPrimingDialogApis = () => {
  function registerPreviewCallback(eventName, callbackFn) {
    if (typeof callbackFn === "function") {
      callbackService.registerCallback(eventName, callbackFn);
    }
  }

  function getLocalFontPrimingDialog(flag) {
    if (callbackService.hasCallback(GET_LOCAL_FONT_PRIMING_DIALOG)) {
      return callbackService.getCallback(GET_LOCAL_FONT_PRIMING_DIALOG)(flag);
    }
    return Promise.reject(`No callback registered for GET_LOCAL_FONT_PRIMING_DIALOG event ${flag}`);
  }
  return {
    registerPreviewCallback,
    getLocalFontPrimingDialog
  };
};
